export default __webpack_public_path__ + "static/media/john-failor.8c59dbe9.jpg";